import { render, staticRenderFns } from "./Crucigrama.vue?vue&type=template&id=2e74f280&scoped=true&"
import script from "./Crucigrama.vue?vue&type=script&lang=js&"
export * from "./Crucigrama.vue?vue&type=script&lang=js&"
import style0 from "./Crucigrama.vue?vue&type=style&index=0&id=2e74f280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e74f280",
  null
  
)

export default component.exports